const modalVideo = () => {

    let $iframe = jQuery(".modal iframe");

    if (!$iframe.length) { return false;}

    let src_thubmnail = $iframe.attr("src");

        let iframeHeight = () => {

        let height = $iframe.width() * 9 / 16;

        $iframe.css("height", height + "px");

    }

    jQuery("#video_modal").on("show.bs.modal", function() {

        if (!$iframe.hasClass("lazyloaded")) {
            $iframe.attr("src", $iframe.attr("data-src"));
            $iframe.addClass("lazyloaded");
        }

    });

    jQuery("#video_modal").on("shown.bs.modal", function() {

        iframeHeight();

    });

    jQuery("#video_modal").on("hide.bs.modal", function() {

        $iframe.attr("src", src_thubmnail);
        $iframe.removeClass("lazyloaded");

    });

};